String.prototype.trunc =
	function( n, useWordBoundary ){
		if (this.length <= n) { return this; }
		var subString = this.substr(0, n-1);
		return (useWordBoundary
				? subString.substr(0, subString.lastIndexOf(' '))
				: subString) + "...";
	};

String.prototype.toProperCase = function () {
	return this.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
};
const urlDecodeAndCapitalize = (string) => {
	return decodeURIComponent(string.replace(/-|[+]/g, ' ')).toProperCase();
};
String.prototype.middleTruncate = function (strLen, separator = '...') {
	let fullStr = this;
	if(fullStr.includes('://www.smashladder.com/') || fullStr.includes('smashladder.localhost'))
	{
		if((fullStr.includes('blogs/view/') || fullStr.includes('news/view/') || fullStr.includes('guides/view/')))
		{
			const split = fullStr.split('/');
			const viewIndex = split.indexOf('view');
			let rest = [];
			rest = split.splice(-2);

			if(rest.length !== 2)
			{
				return fullStr; //Something weird is going on here
			}
			const type = split[viewIndex - 1];
			rest[1] = urlDecodeAndCapitalize(rest[1]);
			return `${type.toProperCase()} - ${rest.join('/')}`;
		}
		if(fullStr.includes('/rankings/'))
		{
			const parts = fullStr.split('/');
			const rankingsIndex = parts.indexOf('rankings');
			const all = parts.splice(rankingsIndex + 1);
			const [ gameName, seasonId, seasonName, pageNumber, regionType, regionName ] = all;
			const displayed = [];
			if(gameName)
			{
				displayed.push('Rankings for ' + urlDecodeAndCapitalize(gameName));
			}
			if(seasonName)
			{
				displayed.push(`Season ${seasonId}-${urlDecodeAndCapitalize(seasonName)}`);
			}
			if(regionType && regionName)
			{
				displayed.push('Region - ' + urlDecodeAndCapitalize(regionName));
			}
			if(pageNumber && pageNumber !== 1)
			{
				displayed.push('Page - ' + pageNumber);
			}
			if(displayed.length >= 1)
			{
				return displayed.join(', ');
			}
		}
	}
	if (fullStr.length <= strLen) return fullStr;

	const sepLen = separator.length,
		charsToShow = strLen - sepLen,
		frontChars = Math.ceil(charsToShow/2),
		backChars = Math.floor(charsToShow/2);

	return fullStr.substr(0, frontChars) +
		separator +
		fullStr.substr(fullStr.length - backChars);
};